import { Badge } from "@cmsgov/ds-medicare-gov";
import React, { FunctionComponent } from "react";
import { CheckmarkIcon } from "../../../components";
import { useTranslate } from "../../../helpers";

export const SimplePharamcyNetworkStatus: FunctionComponent<{
  inNetwork: boolean;
  preferred: boolean;
}> = ({ inNetwork, preferred }) => {
  const t = useTranslate();
  return preferred ? (
    <span className="pharmacy-network-status">
      <Badge className="pharmacy-network-status__icon" variation="success">
        {t("pharmacy.status.preferred")}
      </Badge>{" "}
      {t("pharmacy.terms.in_network").toLowerCase()}
    </span>
  ) : (
    <span>
      <CheckmarkIcon
        classNames="pharmacy-network-status__icon"
        checked={inNetwork}
      />{" "}
      {inNetwork
        ? t("pharmacy.terms.standard_in_network")
        : t("pharmacy.terms.out_of_network")}
    </span>
  );
};
